import React, { useEffect, useState } from "react";
import API from "../../services";
import { toast } from "react-toastify";
import { fetchUserIp } from "../../constants/common";
import { useNavigate, useParams } from "react-router-dom";
import { CancelOutlined } from "@mui/icons-material";
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import "./PlayGame.scss"
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LogoutIcon from '@mui/icons-material/Logout';
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { refreshAuthToken, useAuth } from "../../hooks/hook";
import { setLogout } from "../../store/authReducer";
import HomeIcon from '@mui/icons-material/Home';
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";

type PlayChipsProps = {
  activeWallet: any;
  setLogout: (data: any) => void;
  Browser: any;
}

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  start_param?: string;
}


const PlayGame: React.FC<PlayChipsProps> = ({ activeWallet, setLogout, Browser }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [iframeLoading, setIframeLoading] = useState<boolean>(true);
  const [gameSrc, setGameSrc] = useState<string | null>(null);
  const { gameInfo } = useParams();
  const [gameId, sportId, tgProv, provider, subProv, type, category, tableId, gameLock, sectionLock] = atob(gameInfo || "").split(":");

  const { initializeAuth } = useAuth();

  const getGameUrl = async (userIp: string) => {
    setLoading(true);
    let response;
    try {
      response = await API.post(`/webapp/get-login-url`, {
        userKey: sessionStorage.getItem("userKey"),
        tgProviderId: tgProv,
        clientIp: userIp,
        gameId: gameId,
        sportId: sportId,
        tableId: tableId
      });
    } catch (e) {
      setLoading(false);
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errorDescription);
      handleBackClick();
      return;
    }

    if (response) {
      if (response.data?.sessionUrl === "") {
        toast.error("Plz try again later");
        handleBackClick();
      }
      setGameSrc(response.data.sessionUrl);
      setIframeLoading(true); // Start loading iframe
    }
    setLoading(false);
  };

  const getSportsUrl = async (userIp: string) => {
    setLoading(true);
    let response;
    try {
      response = await API.post(`/webapp/launch-sports`, {
        clientIp: userIp,
        id: gameId,
        provider: provider,
        subProvider: subProv,
        tgProviderId: tgProv,
        type: type
      });
    } catch (e) {
      setLoading(false);
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errorDescription);
      handleBackClick();
      return;
    }
    if (response) {
      if (response.data?.sessionUrl == "") {
        toast.error("Plz try again later");
        handleBackClick();
      }
      setGameSrc(response.data.sessionUrl);
      setIframeLoading(true); // Start loading iframe
    }
    setLoading(false);
  }

  const getSlotsUrl = async (userIp: string) => {
    setLoading(true);
    let response;
    try {
      response = await API.post(`/webapp/launch-slots`, {
        clientIp: userIp,
        id: gameId,
        provider: provider,
        subProvider: subProv,
        tgProviderId: tgProv,
        type: type,
        tableId: tableId
      });
    } catch (e) {
      setLoading(false);
      handleBackClick();
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errorDescription);
      handleBackClick();
      return;
    }
    if (response) {
      if (response.data?.sessionUrl == "") {
        toast.error("Plz try again later");
        handleBackClick();
      }
      setGameSrc(response?.data?.sessionUrl);
      setIframeLoading(true); // Start loading iframe
    }
    setLoading(false);
  }

  const getCasinoUrl = async (userIp: string) => {
    setLoading(true);
    let response;
    try {
      response = await API.post(`/webapp/launch-casino`, {
        clientIp: userIp,
        id: gameId,
        provider: provider,
        subProvider: subProv,
        tgProviderId: tgProv,
        type: type
      });
    } catch (e) {
      setLoading(false);
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errorDescription);
      handleBackClick();
      return;
    }
    if (response) {
      if (response.data?.sessionUrl == "") {
        toast.error("Plz try again later");
        handleBackClick();
      }
      if (response.data?.playchipsEnabled === false && activeWallet === "PLAY_CHIPS") {
        toast.info("Note: You cannot Bet with PlayChips for this Game");
      }
      setGameSrc(response.data.sessionUrl);
      setIframeLoading(true); // Start loading iframe
    }
    setLoading(false);
  }

  const initialize = async () => {
    const userIp = await fetchUserIp();
    if (userIp) {
      getGameUrl(userIp);
    }
  };

  const navigate = useNavigate();

  const handleBackClick = () => {
    const path = sessionStorage.getItem("previousPath");
    if (path) {
      navigate(path);
    } else {
      navigate("/home");
    }
  };

  const handleBackButtonClick = async () => {
    if (type.toLocaleLowerCase() === "site") {
      await siteLogout();
      return
    }
    const path = sessionStorage.getItem("previousPath");
    if (path) {
      navigate(path);
    } else {
      navigate("/home");
    }
  };

  const siteLogout = async () => {
    let response;
    try {
      response = await API.post(`/webapp/site-logout`, {
        tgProviderId: tgProv,
      });

      if (response.data.status !== "RS_OK") {
        toast.error(response.data.errDescription);
        return;
      }
      else if (response.data.status === "RS_OK" && response.data.errDescription !== "") {
        toast.success(response.data.errDescription);
      }
    } catch (e) {
      return;
    }

    const path = sessionStorage.getItem("previousPath");
    if (path === "/home") {
      navigate(`/home`)
    } else {
      navigate(`/promotions`, { state: { Pagetab: "site" } })
    }
  }


  const fullScreen = () => {
    const tg = window?.Telegram?.WebApp;
    console.log("sdf", tg);
    tg?.requestFullscreen();
    // if( window?.Telegram?.WebApp?.i)
  }
  // const tg = window?.Telegram?.WebApp;

  // // Enable the BackButton
  // tg?.BackButton?.show();

  // // Optional: Set up an event listener for the BackButton click
  // tg?.BackButton?.onClick(() => {
  //   console?.log("Back button clicked!");
  //   // window.history.back(); // Navigate back in browser history
  //   handleBackClick();
  // });

  useEffect(() => {
    const tg = window?.Telegram?.WebApp;

    tg?.BackButton?.show();
    tg?.expand();

    const telegramVersion = parseFloat(tg?.version || "0");
    if (telegramVersion >= 8.0) {
      tg?.requestFullscreen();
      if (gameLock === "true") {
        console.log("Game is locked:", gameLock);
        tg?.lockOrientation();
      } else if (sectionLock === "true") {
        console.log("Section is locked:", sectionLock);
        tg?.lockOrientation();
      }
    }

    tg?.BackButton?.onClick(handleBackButtonClick);
    return () => {
      const cleanup = () => {
        const tg = (window as any)?.Telegram?.WebApp;
        tg?.ready();

        tg?.BackButton?.offClick(handleBackButtonClick);
        tg?.BackButton?.hide();
        const telegramVersion = parseFloat(tg?.version || "0");
        if (telegramVersion >= 8.0) {
          tg?.exitFullscreen();
          if (tg?.isOrientationLocked) {
            tg?.unlockOrientation();
          }
        }
      };

      cleanup();
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      refreshAuthToken();
    }, 60 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);



  const [{ x, y }, api] = useSpring(() => ({ x: 16, y: 12 }));

  // Set up drag gesture
  const bind = useDrag(({ offset: [ox, oy] }) => {
    api.start({ x: ox, y: oy }); // Update the spring positions on drag
  }, {
    bounds: { left: 0, right: window.innerWidth, top: 0, bottom: window.innerHeight }, // Define draggable bounds within the window
    rubberband: true, // Add a bit of elastic effect at the edges
  });

  // Blinking animation for home icon
  const blinkAnimation = useSpring({
    from: { opacity: 1, scale: 1 },
    to: [
      { opacity: 0.3, scale: 1.15 },
      { opacity: 1, scale: 1 }
    ],
    config: { duration: 1000 },
    loop: true,
  });

  useEffect(() => {
    initialize();
  }, []);

  return (
    <div className="w-full h-auto fixed gameScreen">
      <div className="w-full h-auto contentsafearea">
        {gameSrc && (
          <>
            <iframe
              src={gameSrc}
              title="Game"
              allowFullScreen
              className="w-full h-full z-[1]"
              sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
              onLoad={() => {
                setIframeLoading(false);
              }}
            />
            {/* Draggable Container */}
            {Browser != "TG" && (
              <animated.div
                {...bind()}
                style={{
                  x,
                  y,
                  position: 'absolute',
                  top: 0,
                  left: "40%",
                  zIndex: 2,
                  backgroundColor: '#2E4C4E',
                  borderRadius: 4,
                  cursor: 'pointer',
                  touchAction: 'none',
                }}
                onClick={() => handleBackButtonClick()}
              >
                <animated.div
                  style={{
                    opacity: blinkAnimation.opacity,
                    transform: blinkAnimation.scale.to(s => `scale(${s})`),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    filter: blinkAnimation.opacity.to(op => `drop-shadow(0 0 ${(1 - op) * 15}px rgba(255, 255, 255, ${1 - op}))`),
                  }}
                >
                  <HomeIcon
                    className="text-border-color"
                    style={{
                      fontSize: '2rem',
                    }}
                  />
                </animated.div>
              </animated.div>
            )}
          </>
        )}
        {(loading || iframeLoading) && (
          <div className="flex justify-center items-center min-h-[92vh] fixed inset-0 bg-black bg-opacity-50 z-[10]">
            <div className="flex items-center fixed top-8 left-8 z-[11]">
              <div className="bg-inputbox-color flex p-1 mr-[0.5rem] rounded"
                onClick={() => handleBackClick()}
              >

                <ArrowBackIcon
                  className="text-border-color aspect-square w-[18px]"
                  style={{ width: '20px', height: '20px' }}
                />
              </div>
              <div className="text-border-color">Go Back</div>
            </div>
            <img src={`/${Loader(domain)}`} alt="Loading..." style={{ height: '10rem', width: 'auto' }} />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    activeWallet: state.userDetails?.activeWallet,
    Browser: state.userDetails.Browser
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setLogout: (data: any) => {
      dispatch(setLogout(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayGame);
